import React from "react";
import { connect } from "react-redux";

import { popDialog } from "../../../store/actions";

import Modal from "colbi_web_ui/lib/components/Modal/Modal";
import { views } from "../../../store";

const DialogController = ({ dialogs, popDialog, i18n }) => {
    return dialogs && dialogs.length
        ? dialogs.map((dialog, index) => {
              const { data, id, title, view } = dialog;
              const View = views[view];
              return View ? (
                  <Modal key={index}>
                      <View
                          title={title}
                          data={data}
                          i18n={i18n}
                          confirm={() => {
                              popDialog(id, true);
                          }}
                          cancel={() => {
                              popDialog(id, false);
                          }}
                      />
                  </Modal>
              ) : null;
          })
        : null;
};

export default connect(
    ({ dialog }) => ({
        dialogs: dialog,
    }),
    {
        popDialog,
    },
)(DialogController);
